import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum MODALBET {
  SUCCESS = "success",
  ERROR = "error",
}

export type InitialState = {
  betResult: null | MODALBET;
  error:string
};

const initialState: InitialState = {
  betResult: null,
  error:""
};

export const betSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setBetResult: (state, action: PayloadAction<null | MODALBET>) => {
      state.betResult = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const { setBetResult, setError } = betSlice.actions;

export default betSlice.reducer;
